//////////////////////////////////////////////////////
// RFI form validation
//////////////////////////////////////////////////////

//Variables for elements/form inputs needed
const firstName = document.getElementById("first_name");
const lastName = document.getElementById("last_name");
const email = document.getElementById("email");
const phone = document.getElementById("mobile");
const degreeSelect = document.querySelector(".degree-select");

//Check before submission
function checkForm() {
  if (
    checkIfBlankOnly(firstName) &&
    checkIfBlankOnly(lastName) &&
    checkIfBlankOnly(degreeSelect) &&
    checkEmail(email) &&
    checkPhone(phone) &&
    (
      checkAssociate() ||
      checkBachelors() ||
      checkMasters() ||
      checkUndergrad() ||
      checkGraduate() ||
      checkEsl()
    )
    //checkIfBlankOnly(degree)
  ) {
    return true;
  }

  return false;
}

//input check while typing

firstName.addEventListener("input", () => {
  checkIfBlankOnly(firstName);
});

lastName.addEventListener("input", () => {
  checkIfBlankOnly(lastName);
});

email.addEventListener("input", () => {
  checkEmail(email);
});

phone.addEventListener("input", () => {
  checkPhone(phone);
});

degreeSelect.addEventListener("input", () => {
  checkIfBlankOnly(degreeSelect);
});

//input check functions

function checkIfBlankOnly(input) {
  if (input.value.trim() === "" || input.value.trim().includes("<")) {
    input.parentElement.setAttribute("data-error", "value required");
    scrollTo({
      top: input.parentElement.offsetTop - 300,
      behavior: "smooth",
    });
    return false;
  }
  input.parentElement.removeAttribute("data-error");
  return true;
}

function checkEmail(input) {
  if (input.value.trim() === "" || input.value.trim().includes("<")) {
    input.parentElement.setAttribute("data-error", "value required");
    window.scrollTo({
      top: input.parentElement.offsetTop - 300,
      behavior: "smooth",
    });
    return false;
  }

  if (!input.value.trim().includes("@")) {
    input.parentElement.setAttribute("data-error", "email requires @");
    scrollTo({
      top: input.parentElement.offsetTop - 300,
      behavior: "smooth",
    });
    return false;
  }

  input.parentElement.removeAttribute("data-error");
  return true;
}

function checkPhone(input) {
  if (input.value.trim() === "") {
    input.parentElement.setAttribute("data-error", "value required");
    scrollTo({
      top: input.parentElement.offsetTop - 300,
      behavior: "smooth",
    });
    return false;
  }

  if (
    !input.value.trim().toString().match(/^\d*$/) ||
    input.value.trim().includes("<")
  ) {
    input.parentElement.setAttribute("data-error", "invalid number");
    scrollTo({
      top: input.parentElement.offsetTop - 300,
      behavior: "smooth",
    });
    return false;
  }  

  input.parentElement.removeAttribute("data-error");
  return true;
}

//below functions check if program is selected on general RFI forms
//try catch blocks catch null.value case on YouTube landing pages

function checkAssociate() {
  const associates = document.getElementById("00N3t00000GSjy8");
  try {
    return associates.value == '' ? false : true;
  } catch {return true}
}

function checkBachelors() {
  const bachelors = document.getElementById("00N3t00000GSjyD");
  try {
    return bachelors.value == '' ? false : true;
  } catch {return true}
}

function checkMasters() {
  const masters = document.getElementById("00N3t00000GSjyN");
  try {
    return masters.value == '' ? false : true;
  } catch {return true}
}

function checkUndergrad() {
  const undergrad = document.getElementById("00N3t00000GSjyS");
  try {
    return undergrad.value == '' ? false : true;
  } catch {return true}
}

function checkGraduate() {
  const grad = document.getElementById("00N3t00000GSjyI");
  try {
    return grad.value == '' ? false : true;
  } catch {return true}
}

function checkEsl() {
  const esl = document.getElementById("00N3t00000GCsU1")
  return esl.value == "English as a Second Language"
}

// degree-program selector on rfi form
// Hides certain options based on what is selected (Associates, bachelor's, master's)

const degree = document.getElementById("degree-field");
const associatesChoice = document.getElementById("associates-field");
const bachelorsChoice = document.getElementById("bachelors-field");
const mastersChoice = document.getElementById("masters-field");
const certChoice = document.getElementById("undergrad-certs-field");
const gradCertChoice = document.getElementById("grad-certs-field");

let choiceArray = [
  associatesChoice,
  bachelorsChoice,
  mastersChoice,
  certChoice,
  gradCertChoice,
];

degree.addEventListener("change", () => {
  if (degree.children[1].value.trim() === "Associate Degree") {
    associatesChoice.style.display = "flex";
    bachelorsChoice.style.display = "none";
    mastersChoice.style.display = "none";
    certChoice.style.display = "none";
    gradCertChoice.style.display = "none";
  }

  if (degree.children[1].value.trim() === "Bachelor's Degree") {
    associatesChoice.style.display = "none";
    bachelorsChoice.style.display = "flex";
    mastersChoice.style.display = "none";
    certChoice.style.display = "none";
    gradCertChoice.style.display = "none";
  }

  if (degree.children[1].value.trim() === "Master's Degree") {
    associatesChoice.style.display = "none";
    bachelorsChoice.style.display = "none";
    mastersChoice.style.display = "flex";
    certChoice.style.display = "none";
    gradCertChoice.style.display = "none";
  }

  if (degree.children[1].value.trim() === "Undergraduate Certificate") {
    associatesChoice.style.display = "none";
    bachelorsChoice.style.display = "none";
    mastersChoice.style.display = "none";
    certChoice.style.display = "flex";
    gradCertChoice.style.display = "none";
  }

  if (degree.children[1].value.trim() === "Graduate Certificate") {
    associatesChoice.style.display = "none";
    bachelorsChoice.style.display = "none";
    mastersChoice.style.display = "none";
    certChoice.style.display = "none";
    gradCertChoice.style.display = "flex";
  }

  if (
    degree.children[1].value.trim() === "Undecided" ||
    degree.children[1].value.trim() === "English as a Second Language"
  ) {
    associatesChoice.style.display = "none";
    bachelorsChoice.style.display = "none";
    mastersChoice.style.display = "none";
    certChoice.style.display = "none";
    gradCertChoice.style.display = "none";
  }
});
